// Toggle itemlist view mode (rows or boxes)
// send mode to server to persist setting

import updateArtNumImportUrl from 'poly-eshop4/eshop/ui/js/art-num-management';
import { disableFilterInputs, finderFilters } from './finder';

$(document).on('change', '[data-itemlist-layout]', function change() {
  const $form = $(this);
  const layout = $form.find('input:checked').val();
  $('.itemlist__items').addClass(`itemlist__items--${layout}`);
  $form.find('input:not(:checked)').each(function () {
    $('.itemlist__items').removeClass(`itemlist__items--${$(this).val()}`);
  });
  $.ajax({
    url: $form.attr('action'),
    type: 'POST',
    data: $form.serialize(),
  });
});

let filterRequest;
const resetFollowingFilters = (target) => {
  const $siblings = $(target).parent().nextAll();
  $siblings.each((index, el) => {
    $(el).find(':input').val('');
  });
};
// Add data attribute actions
export function filterEventHandler(event) {
  Object.values(finderFilters).forEach(($filter) => {
    if ($(event.target).is($filter)) {
      resetFollowingFilters(event.target);
    }
  });
  disableFilterInputs();
  const $this = $(this);
  if ($this.is('.slider')) {
    // Check if current values are the same as initial values.
    const initialStart = parseFloat($this.attr('data-initial-start'));
    const initialEnd = parseFloat($this.attr('data-initial-end'));
    const startValue = parseFloat($this.parent().find('input[name$=_min]').val());
    const endValue = parseFloat($this.parent().find('input[name$=_max]').val());

    if (initialStart === startValue && initialEnd === endValue) {
      // prevent handling sliders "changed" events when nothing has changed (eg. onload)
      // see https://github.com/zurb/foundation-sites/issues/10315
      return null;
    }
  }

  if (event) {
    event.preventDefault();
  }

  // Try to get form using this.form
  // In case of failure (foundation slider etc)
  // use jquery to get closest form
  const $form = $(this.form || $this.closest('form'));
  if (!$form.length) {
    return null;
  }

  // disable slider inputs with range set to min/max
  $form.find('[data-slider]').each(function() {
    const el = $(this);
    const min = el.parent().find('input[name$=_min]');
    const max = el.parent().find('input[name$=_max]');
    if (
      parseFloat(min.val()) === parseFloat(el.attr('data-start'))
      && parseFloat(max.val()) === parseFloat(el.attr('data-end'))
    ) {
      min.get(0).disabled = true;
      max.get(0).disabled = true;
    }
  });

  if ($form.closest('[data-off-canvas]').is('.is-open')) {
    $form.append('<input type="hidden" name="is_filter_open" value="1">');
  }

  if ($form.is('[data-export-definition]')) {
    const url = $form.attr('action') || '';
    filterRequest = $.stores.itemlist.filter(url, false, $form.serialize());
  } else {
    const url = `${$form.attr('action') || ''}?${$form.serialize()}`;
    filterRequest = $.stores.itemlist.filter(url);
    updateArtNumImportUrl();
  }

  // re-enable disabled slider inputs
  $form.find('input.slider-val').each(function() {
    this.disabled = false;
  });

  return filterRequest;
}

$(document).on(
  'change changed.zf.slider',
  '[data-itemlist-filter] input[type=checkbox], [data-itemlist-filter] [data-slider], input[form=itemlist]',
  window.Foundation.util.debounce(filterEventHandler, 0), // prevent double execution when clicking the checkbox
);

$(document).on(
  'change',
  '[data-itemlist-filter] select, [data-itemlist-filter] input[type=number]',
  filterEventHandler,
);

const debouncedFilterEventHandler = window.Foundation.util.debounce(filterEventHandler, 200);

$(document).on(
  'input',
  '[data-itemlist-filter] input[type=search]',
  function(event) {
    // prevent applying filter results during input
    if (filterRequest) {
      filterRequest.abort();
      filterRequest = null;
    }
    debouncedFilterEventHandler.bind(this)(event);
  },
);


$(document).on(
  'keyup.zf.slider',
  '[data-itemlist-filter] [data-slider]',
  debouncedFilterEventHandler,
);

// Itemlist pagination
$(document).on(
  'click',
  '[data-itemlist] [data-pagination] a',
  function (event) {
    event.preventDefault();
    const $form = $(this).closest('form') || $('#itemlist');
    $.stores.itemlist.filter($(this).attr('href'), !$form.is('[data-export-definition]')).then(() => {
      $(document).scrollTop(0);
    });
  },
);

// Reset itemlist filters
$(document).on(
  'click',
  '[data-itemlist-filter-reset]',
  (event) => {
    event.preventDefault();
    const $form = $(document).find('[data-itemlist-filter]');
    const excludes = ['sort', 'limit'];
    if (!$form.find('input[name="q"][type="search"]').length) {
      excludes.push('q');
    }
    const query = $form.serializeArray().filter(filter => excludes.includes(filter.name));
    const url = `${$form.attr('action') || ''}?${$.param(query)}`;
    $.stores.itemlist.filter(url, !$form.is('[data-export-definition]'));
  },
);

// Itemlist tree filter
$(document).on('change', '[data-itemlist-tree-filter] input', function() {
  const isRoot = $(this).closest('[data-itemlist-tree-level]').closest('label').find('input')
    .first().length === 0;
  if (isRoot) {
    $(this).closest('.autocomplete__choice-label').closest('label')
      .find('input')
      .each((idx, input) => {
        if ($(this)[0].id !== input.id) input.checked = false;
      });
  } else {
    $(this).closest('[data-itemlist-tree-level]').closest('label')
      .find('input')
      .first()
      .prop('checked', false);
  }
});

$(document).on('click', '[data-relations-reveal]', function(event) {
  const url = $(this).attr('data-relations-reveal');
  if (url) {
    event.preventDefault();
    $.ajax({
      method: 'GET',
      url,
    }).done((resp) => {
      const element = $(resp).appendTo($('body'));
      element.foundation().foundation('open');
    });
  }
});

$(window).on('popstate', () => {
  $.stores.itemlist.filter(document.location.href, false);
});

function getChunks(array, size = 50) {
  const chunks = [];
  while (array.length) {
    chunks.push(array.splice(0, size));
  }
  return chunks;
}

export function fetchPrices() {
  let url = null;
  const items = [];
  if (document.querySelectorAll('[data-price-async]').length) {
    document.querySelectorAll('[data-price-async]').forEach((item) => {
      url = item.getAttribute('data-price-async');
      items.push(item.getAttribute('data-item'));
    });
  }
  if (url && items) {
    getChunks([...new Set(items)]).forEach((chunk) => {
      $.ajax({
        url,
        data: { i: chunk },
        method: 'GET',
        success: (resp) => {
          $(resp)[0].querySelectorAll('[data-price-async]').forEach((item) => {
            const id = item.getAttribute('data-price-async');
            document.querySelectorAll(`[data-price-async][data-item="${id}"]`)
              .forEach(elem => $(elem).replaceWith(item.innerHTML));
            $(document).trigger('fetchedPrice', [id, item]);
          });
        },
      });
    });
  }
}

export function fetchStockinfo() {
  let url = null;
  const items = [];
  if (document.querySelectorAll('[data-stockinfo-async]').length) {
    document.querySelectorAll('[data-stockinfo-async]').forEach((item) => {
      url = item.getAttribute('data-stockinfo-async');
      items.push(item.getAttribute('data-item'));
    });
  }
  if (url && items) {
    getChunks([...new Set(items)]).forEach((chunk) => {
      $.ajax({
        url,
        data: { i: chunk },
        method: 'GET',
        success: (resp) => {
          $(resp)[0].querySelectorAll('[data-stockinfo-async]').forEach((item) => {
            const id = item.getAttribute('data-stockinfo-async');
            document.querySelectorAll(`[data-stockinfo-async][data-item="${id}"]`)
              .forEach(elem => $(elem).replaceWith(item.innerHTML));
            $(document).trigger('fetchedStockinfo', [id, item]);
          });
        },
      });
    });
  }
}

$(document).ready(() => {
  fetchPrices();
  fetchStockinfo();
});

$(document).ready(() => {
  const $description = $('.item__description');
  if ($description.html()) {
    if ($description.html().indexOf('https://www.hirschi.com/de/catalog/')) {
      const $aTags = $description.find('a');
      if ($aTags.length) {
        $aTags.each((i, aTag) => {
          const $aTag = $(aTag);
          const href = $aTag.attr('href');
          if (href.indexOf('https://www.hirschi.com/de/catalog/') === 0) {
            $aTag.hide();
          }
        });
      }
    }
  }
});

export default {};

